import React from "react";
import SomethingWentWrong from './SomethingWentWrong';

export default function NotFoundPage() {
	return <SomethingWentWrong />
}
